import sdk from '../../../sdk';

export default async function checkSelectedAssetsPermission({
  selectedItems,
  permissionName,
}) {
  const { data: permissions } = await sdk.assets.getPermissions(
    selectedItems, [permissionName],
  );
  // by getAssetPermissions we receive 'false', 'true' or 'mixed'.
  // So if we received 'false' or 'mixed' it means 'false'
  if (permissions[permissionName] !== true) {
    return false;
  }
  return true;
}
